var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitecloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 185,
    viewBox: "0 0 312 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485 231.5C485 255.937 450.732 274.668 443.559 296.714C436.129 319.566 452.558 354.776 438.696 373.797C424.688 393.01 385.967 388.215 366.726 402.197C347.67 416.041 340.352 454.354 317.458 461.771C295.371 468.931 266.985 442.466 242.503 442.466C218.021 442.466 189.636 468.931 167.549 461.771C144.655 454.354 137.337 416.041 118.281 402.197C99.0327 388.215 60.3181 393.01 46.3105 373.797C32.4418 354.776 48.8778 319.566 41.4472 296.714C34.2681 274.661 0 255.937 0 231.5C0 207.063 34.2681 188.332 41.4406 166.286C48.8712 143.434 32.4418 108.224 46.3039 89.2027C60.3115 69.9898 99.0327 74.7848 118.274 60.8027C137.337 46.9594 144.655 8.64575 167.549 1.22872C189.636 -5.93072 218.021 20.5341 242.503 20.5341C266.985 20.5341 295.364 -5.93072 317.458 1.22872C340.352 8.64575 347.67 46.9594 366.726 60.8027C385.974 74.7848 424.688 69.9898 438.696 89.2027C452.565 108.224 436.129 143.434 443.559 166.286C450.732 188.332 485 207.063 485 231.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitecloud);
export default __webpack_public_path__ + "static/media/whitecloud.b5642e986a6932d85b6bb758166bf9de.svg";
export { ForwardRef as ReactComponent };